import Vue, { VueConstructor } from "vue";
import { Route } from "vue-router";

export const drawerRightState = Vue.observable({
  content: null as VueConstructor | null,
  isCollapsed: true,
  isVisible: true,
  isRouteWithDisplayState: (() => false) as (route: Route) => boolean,
  props: {} as { [key: string]: any },
  width: "50vw",
  triggerStyle: {
    left: "-12px",
  },
});
